import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import ExpensesDetail from '../../../components/expenses-detail';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';

import Header2 from '../../../components/headers/header2';
import {Row} from '../../../components/layout';
import ModalTemplate from '../../../components/modal';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import ReimbursementListItemStatus from '../../reimbursements/reimbursement-history/components/ReimbursementListItemStatus';
import {UtilizationItem} from '../UtilizationHistory';

interface UtilizationDetailProps {
  user: any;
  showModal: boolean;
  setShowModal(value: boolean): void;
  labels: typeof strings.pt.insuranceHistory;
  selectedItem: UtilizationItem | undefined;
  expenses: Expense[];
  color: string;
}

function UtilizationDetail({
  showModal,
  setShowModal,
  labels,
  selectedItem,
  expenses,
  user,
  color,
}: UtilizationDetailProps) {
  const sentByMe = selectedItem?.submittedGroup?.toUpperCase().includes('MEMB');

  return (
    <ModalTemplate
      className="reimbursement-detail-modal"
      show={showModal}
      onHide={() => setShowModal(false)}
      cross={true}
      hideFooter={true}>
      <Header2
        style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
        className="reimbursement-history-modal-header">
        {labels?.insuranceHistory_title}
      </Header2>
      {sentByMe ? (
        <Row className="reimbursement-history-modal-subtitle">
          <Row
            className="reimbursement-history-modal-sent"
            style={{...fonts.M, color: '#9C9C9C'}}>
            {labels?.insuranceHistory_detailSentByMe}
          </Row>
          <Row
            style={{...fonts.ML}}
            className="reimbursement-history-modal-status">
            <ReimbursementListItemStatus
              stateDescription={selectedItem?.status}
              color={color}
            />
          </Row>
        </Row>
      ) : (
        <Row></Row>
      )}
      <ExpensesDetail
        estadoId={selectedItem?.statusId}
        process={selectedItem?.auditNbr}
        selectedPatient={`${user.given_name} ${user.family_name}`}
        occorenceDate={selectedItem?.dosFrom}
        expenses={expenses}
        provider={selectedItem?.providerName}
        submittedFiles={[]}
        type={selectedItem?.network.toUpperCase()}
        selectedItem={selectedItem}
      />
    </ModalTemplate>
  );
}

const mapStateToProps = ({strings, user}: any) => ({
  labels: strings.value.pt.insuranceHistory,
  user: user.value,
});

export default compose(connect(mapStateToProps)(UtilizationDetail));
